<template>
  <div class="page-statistic">
    <el-card class="header-card">
      <el-row>
        <el-col class="card-box" :span="3" v-for="(item, index) in headerList" :key="index">
          <div class="header-card-item">{{item.count}}</div>
          <p>{{item.name}}</p>
        </el-col>
      </el-row>
    </el-card>

    <el-row :gutter="20" class="content">
      <el-col :span="12">
        <el-card class="content-item">
          <!-- <h2>总体任务完成情况</h2> -->
          <div class="graph">
            <chart ref="chart1" :options="orgOptions1" :auto-resize="true"></chart>
          </div>
        </el-card>
      </el-col>

      <el-col :span="12">
        <el-card class="content-item">
          <!-- <h2>总体任务完成情况</h2> -->
          <div class="graph">
            <chart ref="chart2" :options="orgOptions2" :auto-resize="true"></chart>
          </div>
        </el-card>
      </el-col>

      <el-col :span="12">
        <el-card class="content-item">
          <!-- <h2>每日完成任务量</h2> -->
          <div class="graph">
            <chart ref="chart2" :options="orgOptions3" :auto-resize="true"></chart>
          </div>
        </el-card>
      </el-col>

      <el-col :span="12">
        <el-card class="content-item">
          <!-- <h2>任务完成排行</h2> -->
          <div class="graph">
            <chart ref="chart2" :options="orgOptions4" :auto-resize="true"></chart>
          </div>
        </el-card>
      </el-col>

      <el-col :span="12">
        <el-card class="content-item">
          <!-- <h2>任务执行者分布</h2> -->
          <div class="graph">
            <chart ref="chart2" :options="orgOptions5" :auto-resize="true"></chart>
          </div>
        </el-card>
      </el-col>

      <el-col :span="12">
        <el-card class="content-item">
          <!-- <h2>成员任务完成情况</h2> -->
          <div class="graph">
            <chart ref="chart2" :options="orgOptions6" :auto-resize="true"></chart>
          </div>
        </el-card>
      </el-col>
    </el-row>

    <!-- <cmp-footer></cmp-footer> -->
  </div>
</template>

<script>
// import cmpFooter from '@cmp/footer'
import chart from 'vue-echarts/components/ECharts'
import 'echarts/lib/chart/line'
import 'echarts/lib/chart/pie'
import 'echarts/lib/component/title' //引入标题组件
import 'echarts/lib/component/legend' //引入图例组件
import 'echarts/lib/component/tooltip' //引入图例组件
import 'echarts/lib/component/dataZoom' // 滚动条插件
import 'echarts/lib/chart/bar'
export default {
  components: {
    // cmpFooter,
    chart
  },
  data() {
    return {
      colorDefaultArr: ['#0590FF', '#50E3C2', '#FFB63E', '#952BFF', '#FF636E'],
      headerList: [
        {
          name: '全部任务',
          count: 0
        },
        {
          name: '已完成',
          count: 0
        },
        {
          name: '未完成',
          count: 0
        },
        {
          name: '已逾期',
          count: 0
        },
        {
          name: '待认领',
          count: 0
        },
        {
          name: '按时完成',
          count: 0
        },
        {
          name: '今日到期',
          count: 0
        },
        {
          name: '逾期完成',
          count: 0
        }
      ],
      orgOptions1: {},
      orgOptions2: {},
      orgOptions3: {},
      orgOptions4: {},
      orgOptions5: {},
      orgOptions6: {}
    }
  },
  methods: {
    getDataList() {
      this.$http
        .get('/statistics/getProjectStatistics', {
          projectId: this.$route.query.projectId
        })
        .then(res => {
          if (res.success) {
            let data = res.result.taskReports
            let topData = res.result.taskStatisticsCount
            this.headerList[0].count = topData.allTask
            this.headerList[1].count = topData.finishTask
            this.headerList[2].count = topData.unFinishTask
            this.headerList[3].count = topData.delayTask
            this.headerList[4].count = topData.unClaimTask
            this.headerList[5].count = topData.inTimeTask
            this.headerList[6].count = topData.todayDeadLineTask
            this.headerList[7].count = topData.delayFinishTask

            // 长度大于length
            if (
              data.taskDistribution.data.length > this.colorDefaultArr.length
            ) {
              for (
                let i = 0;
                i <
                data.taskDistribution.data.length - this.colorDefaultArr.length;
                i++
              ) {
                this.colorDefaultArr.push(this.randomColor()) // 设置随机颜色
              }
            }

            this.setChat1(data.allTaskInfo)
            this.setChat2(data.taskBurnout)
            this.setChat3(data.everyDayTask)
            this.setChat4(data.taskRanking)
            this.setChat5(data.taskDistribution)
            this.setChat6(data.assignerFinish)
          } else {
            this.$message.error(res.message)
          }
        })
    },
    // 总体任务完成情况
    setChat1(data) {
      this.orgOptions1 = {
        title: {
          text: '总体任务完成情况',
          textStyle: {
            fontSize: 18,
            color: '#575962'
            // fontWeight: 'normal'
          }
        },
        tooltip: {
          trigger: 'item',
          formatter: '{a} <br/>{b}: {c} ({d}%)'
        },
        legend: {
          orient: 'vertical',
          x: 'left',
          top: 30,
          data: data.legend
        },
        series: [
          {
            name: '完成情况',
            type: 'pie',
            radius: ['30%', '70%'],
            avoidLabelOverlap: false,
            label: {
              normal: {
                show: false,
                position: 'center'
              },
              emphasis: {
                show: true,
                textStyle: {
                  fontSize: '16',
                  fontWeight: 'bold'
                }
              }
            },
            labelLine: {
              normal: {
                show: false
              }
            },
            data: data.data,
            color: ['#FFB63E', '#0590FF']
          }
        ]
      }
    },
    // 任务燃尽图
    setChat2(data) {
      this.orgOptions2 = {
        title: {
          text: '任务燃尽图',
          textStyle: {
            fontSize: 18,
            color: '#575962'
          }
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            label: {
              backgroundColor: '#6a7985'
            }
          }
        },
        legend: {
          data: data.legend
        },
        toolbox: {
          feature: {
            saveAsImage: {}
          }
        },
        grid: {
          left: '10%',
          right: '12%',
          bottom: '10%',
          containLabel: true
        },
        // grid: {
        //   left: '10%',
        //   bottom:'35%'
        // },
        xAxis: [
          {
            type: 'category',
            boundaryGap: false,
            data: data.xAxis,
            show: false
            // data : ['周一','周二','周三','周四','周五','周六','周日']
            // axisLabel: {
            //   rotate:40
            // }
          }
        ],
        yAxis: [
          {
            type: 'value'
          }
        ],
        // x轴拖动
        dataZoom: {
          type: 'slider',
          realtime: true, //拖动滚动条时是否动态的更新图表数据
          height: 20, //滚动条高度
          start: 0, //滚动条开始位置（共100等份）
          end: 100 //结束位置（共100等份）
        },
        series: data.data,
        // series : [
        //   {
        //     name:'待处理',
        //     type:'line',
        //     stack: '总量',
        //     smooth: true,
        //     symbol: 'none',   // 没有圆圈
        //     areaStyle: {},
        //     data:[120, 132, 101, 134, 90, 230, 210]
        //   },
        //   {
        //     name:'已延误',
        //     type:'line',
        //     stack: '总量',
        //     smooth: true,
        //     areaStyle: {},
        //     data:[220, 182, 191, 234, 290, 330, 310]
        //   },
        //   {
        //     name:'已完成',
        //     type:'line',
        //     stack: '总量',
        //     smooth: true,
        //     areaStyle: {},
        //     data:[150, 232, 201, 154, 190, 330, 410]
        //   }
        // ],
        color: ['#0590FF', '#FFB63E', '#F25151']
      }
    },
    // 每日完成任务量
    setChat3(data) {
      this.orgOptions3 = {
        title: {
          text: '每日完成任务量',
          textStyle: {
            fontSize: 18,
            color: '#575962'
          }
        },
        tooltip: {
          trigger: 'axis'
        },
        grid: {
          left: '10%',
          right: '12%',
          bottom: '11%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: data.xAxis,
          // data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']
          // show: false,
          axisLabel: {
            // interval:0,
            rotate: 30
          }
        },
        yAxis: {
          type: 'value'
        },
        // x轴拖动
        dataZoom: {
          type: 'slider',
          realtime: true, //拖动滚动条时是否动态的更新图表数据
          height: 20, //滚动条高度
          start: 0, //滚动条开始位置（共100等份）
          end: 100 //结束位置（共100等份）
        },
        series: data.data,
        // data: [820, 932, 901, 934, 1290, 1330, 1320],
        type: 'line',
        // smooth: true
        color: ['#0590FF']
      }
    },
    // 任务完成排行
    setChat4(data) {
      this.orgOptions4 = {
        title: {
          text: '任务完成排行',
          textStyle: {
            fontSize: 18,
            color: '#575962'
          }
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
          }
        },
        legend: {
          data: data.legend
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: [
          {
            type: 'category',
            data: data.xAxis
          }
        ],
        yAxis: [
          {
            type: 'value'
          }
        ],
        series: data.data,
        //   {
        //     name:'待认领',
        //     type:'bar',
        //     stack: '广告',
        //     data: data.data
        //   }
        // ],
        color: ['#0590FF']
      }
    },
    // 任务执行者分布
    setChat5(data) {
      this.orgOptions5 = {
        title: {
          text: '任务执行者分布',
          textStyle: {
            fontSize: 18,
            color: '#575962'
          }
        },
        tooltip: {
          trigger: 'item',
          formatter: '{a} <br/>{b}: {c} ({d}%)'
        },
        legend: {
          orient: 'vertical',
          x: 'left',
          top: 30,
          data: data.legend
        },
        series: [
          {
            name: '任务执行者',
            type: 'pie',
            radius: ['30%', '70%'],
            avoidLabelOverlap: false,
            label: {
              normal: {
                show: false,
                position: 'center'
              },
              emphasis: {
                show: true,
                textStyle: {
                  fontSize: '16',
                  fontWeight: 'bold'
                }
              }
            },
            labelLine: {
              normal: {
                show: false
              }
            },
            data: data.data,
            // data:[
            //   {value:335, name:'已完成'},
            //   {value:310, name:'未完成'}
            // ],
            color: [...this.colorDefaultArr]
          }
        ]
      }
    },
    // 成员任务完成情况
    setChat6(data) {
      this.orgOptions6 = {
        title: {
          text: '成员任务完成情况',
          textStyle: {
            fontSize: 18,
            color: '#575962'
          }
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
          }
        },
        legend: {
          data: data.legend
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: [
          {
            type: 'category',
            data: data.xAxis
          }
        ],
        yAxis: [
          {
            type: 'value'
          }
        ],
        series: data.data,
        // series : [
        //   {
        //     name:'已完成',
        //     type:'bar',
        //     stack: '广告',
        //     data:[120, 132, 101, 134, 90, 230, 210]
        //   },
        //   {
        //     name:'未完成',
        //     type:'bar',
        //     stack: '广告',
        //     data:[220, 182, 191, 234, 290, 330, 310]
        //   }
        // ],
        color: ['#0590FF', '#FFB63E', '#F25151']
      }
    },
    randomColor() {
      let colorElements = '0,1,2,3,4,5,6,7,8,9,a,b,c,d,e,f'
      let colorArray = colorElements.split(',')
      let color = '#'
      for (let i = 0; i < 6; i++) {
        color += colorArray[Math.floor(Math.random() * 16)]
      }

      let hasCommon = false
      for (let i = 0; i < this.colorDefaultArr; i++) {
        if (color === this.colorDefaultArr[i]) {
          hasCommon = true
          break
        }
      }
      if (hasCommon) {
        this.randomColor()
        return
      }
      return color
      // return  '#' + (function(color){
      //     return (color +=  '0123456789abcdef'[Math.floor(Math.random()*16)])
      //     && (color.length == 6) ?  color : arguments.callee(color);
      // })('');
    }
  },
  created() {
    this.getDataList()
  },
  mounted() {}
}
</script>

<style lang="scss" scoped>
.page-statistic {
  padding: 10px 30px;
  width: 1370px;
  margin: 0 auto;
  .header-card {
    margin: 20px 0;
    text-align: center;
    .header-card-item {
      font-size: 32px;
      color: $color5;
    }
    .card-box:nth-child(2) .header-card-item {
      color: $primary;
    }
    .card-box:nth-child(3) .header-card-item {
      color: $warning;
    }
    .card-box:nth-child(4) .header-card-item {
      color: $danger;
    }
  }
  .content {
    .content-item {
      margin-bottom: 20px;
      .graph {
        height: 300px;
        .echarts {
          width: 100%;
          height: 100%;
        }
      }
    }
  }
  /deep/ .el-card__body {
    padding: 20px;
  }
}
</style>



